module.exports = __webpack_public_path__ + "fa30ab5b3b988405a0b9347f17909eed.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/beady-5.png
// module id = 2095
// module chunks = 0